import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import { InputNumber } from "primereact/inputnumber";

import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";

import {
  addPosicion,
  getPosicion,
  getBodegasAct,
  getEstantesAct,
} from "../../../../../API/Suministros/SuministrosRequest";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";

const PosicionesCrudModal = ({
  posicion,
  posicionesDialog,
  setPosicionesDialog,
  toastRef,
  getPos,
  modo,
}) => {
  // const userAuth = JSON.parse(localStorage.getItem('ppfUser'));

  const toastDialog = useRef(null);
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);


  const [show, setShow] = useState(false);

  const [estados, setEstados] = useState([{}]);
  const [bodega, setBodegas] = useState([{}]);
  const [estante, setEstante] = useState([{}]);
  const [posicionList, setPosicionList] = useState([{}]);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdPosicion: -1,
    NombrePosicion: "",
    NumeroPosicion: "",
    Bandeja: "",
    IdStatus: posicion ? posicion?.IdStatus : 5,
    IdBodega: "",
    IdEstante: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const estadosTempo = await getEstadosCategory("General");
    const bodegaActiva = await getBodegasAct();
    const estanteActiva = await getEstantesAct();
    const pos = await getPosicion();

    setEstados(estadosTempo);
    setBodegas(bodegaActiva);
    setEstante(estanteActiva);
    setPosicionList(pos);

    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === posicion?.IdStatus);

    setValues({
      ...posicion,
      Estado: estadoInicial,

      Bodega: bodegaActiva.find((b) => posicion?.IdBodega === b.IdBodega),
      Estante: estanteActiva.find((es) => posicion?.IdEstante === es.IdEstante),
    });
    setLoading(false)
  };

  const onHide = () => {
    setPosicionesDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombrePosicion) {
      error.NombrePosicion = true;
      error.error = true;
    }
    if (!values.NumeroPosicion) {
      error.NumeroPosicion = true;
      error.error = true;
    }
    // if (!values.Bandeja) {
    //   error.Bandeja = true;
    //   error.error = true;
    // }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    if (!values.Bodega || !values.Bodega.IdBodega) {
      error.IdBodega = true;
      error.error = true;
    }

    if (!values.Estante || !values.Estante.IdEstante) {
      error.IdEstante = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const posicionExistsWithSameName = () => {
    const sameNamePosiciones = posicionList.filter((item) =>
        item.NombrePosicion?.toLowerCase().trim() === values.NombrePosicion?.toLowerCase().trim() &&
        Number(item.IdBodega) === Number(values.Bodega?.IdBodega) &&
        Number(item.IdEstante) === Number(values.Estante?.IdEstante) &&
        Number(item.IdPosicion) !== Number(values.IdPosicion)
    );

    return sameNamePosiciones.length > 0;
  };

  const posicionExistsWithSameNumber = () => {
    const sameNumberPosiciones = posicionList.filter(
      (item) =>
        Number(item.NumeroPosicion) === Number(values.NumeroPosicion) &&
        Number(item.IdBodega) === Number(values.Bodega?.IdBodega) &&
        Number(item.IdEstante) === Number(values.Estante?.IdEstante) &&
        Number(item.IdPosicion) !== Number(values.IdPosicion)
    );

    return sameNumberPosiciones.length > 0;
  };

  const agregarPosicion = async () => {
    const e = verificarInfo();
    if (!e.error) {
      if (posicionExistsWithSameName()) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe una fila con el mismo nombre en esta bodega y estante."
        );
        return;
      }

      if (posicionExistsWithSameNumber()) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe una fila con el mismo numero en esta bodega y estante."
        );
        return;
      }

      let estadoId = null;
      if (values.Estado) {
        estadoId = values.Estado.IdStatus;
      }
      const a = {
        IdPosicion: values?.IdPosicion,
        NombrePosicion: values.NombrePosicion,
        NumeroPosicion: values.NumeroPosicion,
        Bandeja: values.Bandeja,
        IdStatus: estadoId,
        IdBodega: values.Bodega.IdBodega,
        IdEstante: values.Estante.IdEstante,
        IdUserCreate: userAuth?.IdUser
      };
      const t = await addPosicion(a);

      if(t[0]?.ERROR === 1){
        onHide();
        toastShow(toastRef, "success", "Datos Agregados", t[0]?.Mensaje);
        getPos();
      }else{
        toastShow(toast, "error", "Error al agregar", t[0]?.Mensaje);
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarPosicion();
          } else {
            agregarPosicion();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (posicionesDialog) {
      getValoresIniciales();
    }
  }, [posicionesDialog]);

  const dialogTitle = modo === "Crear" ? "Nueva Fila" : "Modificar Fila";

  return (
    <div>
      <Dialog
        visible={posicionesDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        appendTo="self"
        style={{ width: "55vw" }}
      >
        <div id="Dialog">
        <Loader loading={loading} querySelector={"#Dialog"} />
        <div style={{ width: "100", margin: "auto" }}>
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>
          <Toast ref={toastDialog} style={{ zIndex: 50000 }} />
        <Toast ref={toast} style={{ zIndex: 50000 }} />

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="NombrePosicion"
                  value={values.NombrePosicion}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.NombrePosicion ? "p-invalid" : ""}
                />
                <label htmlFor="NombrePosicion">Nombre de la Fila</label>
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputNumber
                  name="NumeroPosicion"
                  value={values.NumeroPosicion}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  useGrouping={false}
                  className={error.NumeroPosicion ? "p-invalid" : ""}
                />
                <label htmlFor="NumeroPosicion">Numero de Fila</label>
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Bodega"}
                  value={values.Bodega}
                  items={bodega}
                  field={"NombreBodega"}
                  label={"Bodega"}
                  handleInputChange={(e) => {
                    handleInputChange(e);
                    setValues(prevValues => ({
                      ...prevValues,
                      Estante: null
                    }));
                  }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdBodega ? "p-invalid" : ""}
                />
              </span>
            </div>

            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Estante"}
                  value={values.Estante}
                  items={estante}
                  field={"NombreEstante"}
                  label={"Estante"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdEstante ? "p-invalid" : ""}
                  filterValue={values?.Bodega}
                  itemsFilter={(e) => {
                    let filtro = estante.filter(
                      (s) => s.IdBodega === values?.Bodega?.IdBodega
                    );
                    let filtro2 = values?.Bodega?.IdBodega

                    if(filtro?.length === 0 && filtro2){
                      toastShow(
                        toast,
                        "warn",
                        "Seleccione otra Bodega",
                        "La Bodega seleccionada no cuenta con estantes disponibles"
                      );
                    }
                    return filtro
                  }}
                />
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            {/* <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <InputText
                  name="Bandeja"
                  value={values.Bandeja}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.Bandeja ? "p-invalid" : ""}
                />
                <label htmlFor="Bandeja">Bandeja</label>
              </span>
            </div> */}

            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Estado"}
                  value={values.Estado}
                  items={estados}
                  field={"StatusName"}
                  label={"Estado"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdStatus ? "p-invalid" : ""}
                />
              </span>
            </div>
          </div>
        </div>
        </div>
      </Dialog>
    </div>
  );
};

export default PosicionesCrudModal;
